import React, { useState, useEffect } from 'react';
import './PerformanceReport.scss';

const PerformanceReport = () => {
  const [performanceData, setPerformanceData] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only run in development mode
    if (process.env.NODE_ENV === 'development') {
      const calculatePerformance = () => {
        // Get performance metrics
        const navigationEntries = performance.getEntriesByType('navigation');
        const paintEntries = performance.getEntriesByType('paint');
        
        if (navigationEntries.length > 0) {
          const navEntry = navigationEntries[0];
          const paintEntry = paintEntries.find(entry => entry.name === 'first-contentful-paint');
          
          setPerformanceData({
            loadTime: navEntry.loadEventEnd - navEntry.loadEventStart,
            domContentLoaded: navEntry.domContentLoadedEventEnd - navEntry.domContentLoadedEventStart,
            firstPaint: paintEntry ? paintEntry.startTime : null,
            resourcesLoaded: performance.getEntriesByType('resource').length
          });
        }
      };

      // Calculate performance after page load
      if (document.readyState === 'complete') {
        calculatePerformance();
      } else {
        window.addEventListener('load', calculatePerformance);
      }

      return () => {
        window.removeEventListener('load', calculatePerformance);
      };
    }
  }, []);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  if (process.env.NODE_ENV !== 'development' || !performanceData) {
    return null;
  }

  return (
    <div className={`performance-report ${isVisible ? 'visible' : ''}`}>
      <button className="performance-toggle" onClick={toggleVisibility}>
        {isVisible ? 'Hide' : 'Show'} Performance
      </button>
      {isVisible && (
        <div className="performance-data">
          <h4>Performance Metrics</h4>
          <ul>
            <li>Load Time: {performanceData.loadTime}ms</li>
            <li>DOM Content Loaded: {performanceData.domContentLoaded}ms</li>
            <li>First Paint: {performanceData.firstPaint ? `${performanceData.firstPaint}ms` : 'N/A'}</li>
            <li>Resources Loaded: {performanceData.resourcesLoaded}</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default PerformanceReport;
